import Vue from 'vue'
import Vuex from 'vuex'
import state from './state'
import mutations from './mutations'

import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

const store = new Vuex.Store({
    state:state,
    mutations : mutations,
    plugins: [createPersistedState()]
})

export default store
